// removed by extract-text-webpack-plugin
module.exports = {"component":"_3MLrombYcvuGcBXggyb9Z6","versionRow":"_3AayKGJuMVeXRU42l3p4Pd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Version/Version.css
// module id = 996
// module chunks = 0